import * as React from 'react';
import * as CSSModules from 'react-css-modules';

const styles = require('./help.less');

@CSSModules(styles)
class HowToInsertSimcard extends React.Component<{}> {
    render() {
        return (
            <>{(window.location.href = __('routes.how-to-insert-sim-card'))}</>
        );
    }
}

export { HowToInsertSimcard };
